import React from "react";
import * as R from "ramda";
import cx from "classnames";
import Icon from "../Icon/Icon.jsx";
import { number, func } from "prop-types";

const propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  onPaginationChange: func.isRequired,
};

const Pagination = (props) => {
  const { totalResults, resultsPerPage, currentPage, onPaginationChange } =
    props;

  const totalPages = Math.ceil(totalResults / resultsPerPage);

  const isHidden = (value, currentPage, totalPages) => {
    if (totalPages <= 8) {
      return false;
    }

    // current Page
    if (value === currentPage) {
      return false;
    }

    // first and last page
    if (value === 1 || value === totalPages) {
      return false;
    }

    // previous and next page
    if (value === currentPage - 1 || value === currentPage + 1) {
      return false;
    }

    // start or end position
    if (
      (currentPage <= 2 || currentPage >= totalPages - 1) &&
      (value <= 3 || value >= totalPages - 2)
    ) {
      return false;
    }

    return true;
  };

  const renderPageButton = (value, currentPage, totalPages) => {
    const skipButton = isHidden(value, currentPage, totalPages);

    return (
      <div
        className={cx("pagination__page-button", {
          "pagination__page-button--hidden": skipButton,
        })}
        key={value}
      >
        {skipButton ? (
          <span>…</span>
        ) : (
          <button
            className={cx("btn", {
              "btn--active": Number(currentPage) === value,
            })}
            type="button"
            disabled={currentPage === value}
            onClick={() => onPaginationChange(value)}
            data-gtm-element="dcl page button"
          >
            {value}
          </button>
        )}
      </div>
    );
  };

  const renderButtons = (totalPages, currentPage) => {
    //R.range create an array from x to y of incrementing numbers
    return R.range(1, totalPages + 1).map((page) =>
      renderPageButton(page, currentPage, totalPages),
    );
  };

  return (
    <div className="pagination">
      <nav className="pagination__pages" aria-label="pagination">
        <button
          className="btn pagination__prev-button"
          type="button"
          disabled={currentPage <= 1}
          onClick={() => onPaginationChange(currentPage - 1)}
          aria-label="Previous Page"
          data-gtm-element="dcl previous page button"
        >
          <Icon iconName="arrow-left" />
        </button>
        {renderButtons(totalPages, currentPage)}
        <button
          className="btn pagination__next-button"
          type="button"
          disabled={currentPage >= totalPages}
          onClick={() => onPaginationChange(currentPage + 1)}
          aria-label="Next Page"
          data-gtm-element="dcl next page button"
        >
          <Icon iconName="arrow-right" />
        </button>
      </nav>
    </div>
  );
};

Pagination.propTypes = propTypes;
export default Pagination;
